import { ApolloError } from '@apollo/client';
import { AptunoErrorType, AptunoErrorTypeMapper } from '../Core/domain';
import { AptunoError } from '../models/error.model';

export const ResponseApolloErrorMapping = (error: ApolloError): AptunoError => {
  const isNetworkError = !!error.networkError;
  const isRiskError = () => !!error?.graphQLErrors[0]?.extensions?.code;
  const isDomainError = () => !!error?.graphQLErrors[0]?.extensions?.exception?.errors?.[0];

  const domainError: AptunoError | undefined = error?.graphQLErrors[0]?.extensions?.exception?.errors?.[0];

  if (isNetworkError)
    return {
      code: 'NETWORK_ERROR',
      type: AptunoErrorType.UNKNOWN,
    };

  if (isDomainError())
    return (
      domainError || {
        code: 'DEFAULT',
        type: AptunoErrorType.UNKNOWN,
      }
    );

  if (isRiskError()) {
    const err = error.graphQLErrors[0];

    return {
      type: AptunoErrorTypeMapper[err.extensions.classification] || AptunoErrorType.UNKNOWN,
      code: err.extensions.code,
    };
  }

  return {
    code: 'DEFAULT',
    type: AptunoErrorType.UNKNOWN,
  };
};
